const occupation = [
  {
    label: 'Aposentado ou pensionista (INSS)',
    id: 'retired',
    value: 'retired',
    icon: {
      name: 'inss-bold',
      type: 'outlined',
      isLocal: true
    }
  },
  {
    label: 'Funcionário público',
    id: 'government-employee',
    value: 'government-employee',
    icon: {
      name: 'gerente',
      type: 'outlined'
    }
  },
  {
    label: 'Profissional liberal',
    id: 'self-employed',
    value: 'self-employed',
    icon: {
      name: 'lideranca',
      type: 'outlined'
    }
  },
  {
    label: 'Assalariado',
    id: 'employee',
    value: 'employee',
    icon: {
      name: 'carteirada',
      type: 'outlined'
    }
  },
  {
    label: 'Empresário ou autônomo',
    id: 'entrepreneur',
    value: 'entrepreneur',
    icon: {
      name: 'mala',
      type: 'outlined'
    }
  },
  {
    label: 'Desempregado',
    id: 'unemployed',
    value: 'unemployed',
    icon: {
      name: 'busca',
      type: 'outlined'
    }
  }
]

export default occupation
